"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var helpers_1 = require("../helpers");
var gameobject_1 = require("./gameobject");
/**
 * Renders a piece of JSX into a Phaser scene.
 *
 * @param element - Element that you want to display.
 * @param scene - Phaser scene.
 */
function render(element, scene) {
    (0, helpers_1.setScene)(scene);
    var gameObject = (0, gameobject_1.createGameObject)(element, scene);
    if (gameObject) {
        scene.add.existing(gameObject);
    }
}
exports.render = render;
//# sourceMappingURL=render.js.map